import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import OutletsTab from "@/components/settings/OutletsTab";
import FieldsTab from "@/components/settings/FieldsTab";
import GoogleTab from "@/components/settings/GoogleTab";
import GmailTab from "@/components/settings/GmailTab";
import ReeloTab from "@/components/settings/ReeloTab";
import LogoTab from "@/components/settings/LogoTab";
import ReportsTab from "@/components/settings/ReportsTab";
import UsersTab from "@/components/settings/UsersTab";
import AuditTab from "@/components/settings/AuditTab";
import HelpTab from "@/components/settings/HelpTab";

const TABS = [["outlets", "Brands & outlets", OutletsTab], ["fields", "Fields & lists", FieldsTab], ["google", "Google Sheets", GoogleTab], ["gmail", "Gmail auto-import", GmailTab], ["reelo", "Reelo auto-import", ReeloTab], ["reports", "Weekly reports", ReportsTab], ["users", "Users", UsersTab], ["logo", "Logo", LogoTab], ["audit", "Audit log", AuditTab], ["help", "Help", HelpTab]];

const GMAIL_MSG = {
  connected: ["success", "Gmail connected"],
  error: ["error", "Couldn't connect Gmail. Check the Client ID/secret and redirect URI, then try again."],
  norefresh: ["error", "Google didn't grant offline access. Please press 'Sign in with Google' again."],
};

export default function Settings() {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    const m = GMAIL_MSG[params.get("gmail")];
    if (m) {
      toast[m[0]](m[1], { id: "gmail-oauth" });
      setParams({ tab: "gmail" }, { replace: true });
    }
  }, [params, setParams]);
  return (
    <div data-testid="settings-page" className="max-w-6xl">
      <PageHeader title="Settings" subtitle="Outlets, fields, Google connection and who can use the app." />
      <Tabs defaultValue={params.get("tab") || "outlets"}>
        <TabsList className="mb-6 h-auto flex-wrap justify-start gap-1 rounded-2xl bg-slate-100 p-1">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`settings-tab-${v}`} className="rounded-xl px-4 py-2 text-sm data-[state=active]:shadow-sm">{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
